export enum SignatureStatus {
  AwaitingSignature = 'awaiting_signature',
  Rejected = 'rejected',
  Signed = 'signed',
}